module.exports = require("mini-css-extract-plugin");